import { toAbsoluteUrl } from "@common-metronic/helpers"
import { usePersonnelDetailsContext } from "./PersonnelDetails"
import FileAndDriveHelper from "@common-helpers/FileAndDriveHelper"
import MyLoadingOverlay from "../../../../common/components/MyLoadingOverlay"
import React, { useState } from "react"
import Navigation from "./_Navigation"
import clsx from "clsx"
import moment from "moment"
import Swal from "sweetalert2"
import { toast } from "react-toastify"
import useUser from "../../../hooks/useUser"
import { setPersonnelCodeAnalytiqueRequest, setPersonnelNumeroImmatCegedimRequest } from "../core/_requests"
import { CONST_PERSONNEL_STATUT_STATUT_NON_SALARIE } from "@common-constants/*"

const SideBar = () => {
     const context = usePersonnelDetailsContext()
     const details = context.detailsQuery.data
     const [isAvatarLoading, setIsAvatarLoading] = useState<boolean>(true)
     const { canSeeStaffCegedimAnalytique, canEditStaffCegedimAnalytique } = useUser()

     const personnelId = details?.personnel.id
     const isNonSalarie = details?.personnel.statut === CONST_PERSONNEL_STATUT_STATUT_NON_SALARIE

     const handleEditCodeAnalytique = () => {
          Swal.fire({
               title: "Code analytique",
               input: "text",
               inputValue: details?.personnel.codeAnalytique ?? "",
               inputPlaceholder: "Code analytique",
               showCancelButton: true,
               confirmButtonText: "Enregistrer",
               cancelButtonText: "Annuler",
               confirmButtonColor: "#009ef7",
          }).then(res => {
               if (!res.isConfirmed || !personnelId) return
               setPersonnelCodeAnalytiqueRequest(personnelId, res.value ?? "")
                    .then(() => {
                         toast.success("Code analytique mis à jour.")
                         context.detailsQuery.refetch()
                    })
                    .catch(e => toast.error(e?.response?.data?.detail ?? "Échec de la mise à jour.", { autoClose: false }))
          })
     }

     const handleEditCegedim = () => {
          Swal.fire({
               title: "N° immat. CEGEDIM",
               input: "text",
               inputValue: details?.personnel.CEGEDIM_mmat ?? "",
               inputPlaceholder: "N° immat. CEGEDIM",
               showCancelButton: true,
               confirmButtonText: "Enregistrer",
               cancelButtonText: "Annuler",
               confirmButtonColor: "#009ef7",
          }).then(res => {
               if (!res.isConfirmed || !personnelId) return
               setPersonnelNumeroImmatCegedimRequest(personnelId, res.value ?? "")
                    .then(() => {
                         toast.success("N° immat. CEGEDIM mis à jour.")
                         context.detailsQuery.refetch()
                    })
                    .catch(e => toast.error(e?.response?.data?.detail ?? "Échec de la mise à jour.", { autoClose: false }))
          })
     }

     return (
          <>
               <div className="flex-column flex-lg-row-auto w-lg-350px w-xl-350px">
                    {/*begin::Card*/}
                    <div className="card mb-5 mb-xl-8">
                         {/*begin::Card body*/}
                         <div className="card-body">
                              <Navigation />

                              {/*begin::Summary*/}
                              {/*begin::User Info*/}
                              <div className="d-flex flex-center flex-column py-5">
                                   {/*begin::Avatar*/}
                                   <MyLoadingOverlay isActive={isAvatarLoading} classNames={"h-100px"} styles={{ borderRadius: "50%" }}>
                                        <div className="symbol symbol-100px symbol-circle mb-7">
                                             <img
                                                  src={
                                                       details?.personnel.avatarGoogleDriveId
                                                            ? FileAndDriveHelper.getThumbnailDriveUrl(details?.personnel.avatarGoogleDriveId)
                                                            : toAbsoluteUrl("/media/svg/avatars/blank.svg")
                                                  }
                                                  alt="Avatar"
                                                  onLoad={() => setIsAvatarLoading(false)}
                                             />
                                             <div
                                                  className={clsx(
                                                       "position-absolute translate-middle top-50 start-100 mb-2 bg-success rounded-circle border border-4 border-white h-15px w-15px",
                                                       {
                                                            "bg-success": !details?.user?.dateFinAccess || moment().isBefore(details?.user?.dateFinAccess),
                                                            "bg-danger": moment().isAfter(details?.user?.dateFinAccess),
                                                       }
                                                  )}
                                             />
                                        </div>
                                   </MyLoadingOverlay>
                                   {/*end::Avatar*/}
                                   {/*begin::Name*/}
                                   <span className="fs-3 text-gray-800 fw-bolder mb-3">{details?.personnel.prenomNom}</span>
                                   {/*end::Name*/}
                                   {/*begin::Position*/}
                                   <div className="mb-9">
                                        {/*begin::Badge*/}
                                        <div className="badge badge-lg badge-light-primary d-inline">
                                             {details?.personnel.personnelPostes && details?.personnel.personnelPostes?.length > 0
                                                  ? details?.personnel.personnelPostes[0].poste?.nom
                                                  : "Non renseigné"}
                                        </div>
                                        {/*begin::Badge*/}
                                   </div>
                                   {/*end::Position*/}
                              </div>
                              {/*end::User Info*/}
                              {/*end::Summary*/}
                              {/*begin::Details toggle*/}
                              <div className="d-flex flex-stack fs-4 py-3">
                                   <div className="fw-bolder">Details</div>
                              </div>
                              {/*end::Details toggle*/}
                              <div className="separator" />
                              {/*begin::Details content*/}
                              <div id="kt_user_view_details" className="collapse show">
                                   <div className="pb-5 fs-6">
                                        {/*begin::Details item*/}
                                        <div className="fw-bolder mt-5">Email</div>
                                        <div className="text-gray-600">
                                             <a href={`mailto:${details?.personnel.mailProfessionnel}`} className="text-primary text-hover-primary fw-bold">
                                                  {details?.personnel.mailProfessionnel}
                                             </a>
                                        </div>
                                        {/*begin::Details item*/}
                                        {/*begin::Details item*/}
                                        <div className="fw-bolder mt-5">Tél.</div>
                                        <div className="text-gray-600">
                                             <a
                                                  href={`tel:${
                                                       details?.personnel.telProfessionnelIndicatif ? details?.personnel.telProfessionnelIndicatif.phoneCodeWithPlusPrefix : ""
                                                  } ${details?.personnel.telProfessionnel}`}
                                                  className="text-primary text-hover-primary fw-bold"
                                             >
                                                  {details?.personnel.telProfessionnelIndicatif ? details?.personnel.telProfessionnelIndicatif.phoneCodeWithPlusPrefix : ""}{" "}
                                                  {details?.personnel.telProfessionnel}
                                             </a>
                                        </div>
                                        {/*begin::Details item*/}
                                        {/*begin::Details item*/}
                                        <div className="fw-bolder mt-5">Agence</div>
                                        <div className="text-gray-600">{details?.personnel.agence?.nom}</div>
                                        {/*begin::Details item*/}
                                        {/*begin::Details item*/}
                                        <div className="fw-bolder mt-5">Dernière connexion</div>
                                        <div className="text-gray-600">
                                             {details?.user?.dateDerniereConnexion ? details?.user?.dateDerniereConnexion?.format("dddd D MMMM YYYY à H[h]mm") : "Jamais connecté"}
                                        </div>
                                        {/*begin::Details item*/}
                                        {/*begin::Details item*/}
                                        <div className="fw-bolder mt-5">LinkedIn</div>
                                        <div className="text-gray-600">
                                             {details?.personnel.linkedinUrl ? (
                                                  <a
                                                       href={details?.personnel.linkedinUrl}
                                                       target="_blank"
                                                       rel="noopener noreferrer"
                                                       className="text-primary text-hover-primary fw-bold"
                                                  >
                                                       {details?.personnel.linkedinUrl}
                                                  </a>
                                             ) : (
                                                  <span className={"text-warning fw-light"}>Non renseigné</span>
                                             )}
                                        </div>
                                        {/*begin::Details item*/}

                                        {/* N° immat. CEGEDIM (salarié) + Code analytique — accès complet ou restreint */}
                                        {canSeeStaffCegedimAnalytique() && (
                                             <>
                                                  {!isNonSalarie && (
                                                       <>
                                                            <div className="fw-bolder mt-5 d-flex align-items-center">
                                                                 N° immat. CEGEDIM
                                                                 {/* Le n° CEGEDIM ne peut être défini qu'une seule fois : plus d'édition une fois renseigné. */}
                                                                 {canEditStaffCegedimAnalytique() && !details?.personnel.CEGEDIM_mmat && (
                                                                      <i className="fas fa-pen text-primary fs-8 ms-2 cursor-pointer text-hover-dark" onClick={handleEditCegedim} />
                                                                 )}
                                                            </div>
                                                            <div className="text-gray-600">
                                                                 {details?.personnel.CEGEDIM_mmat || <span className="text-warning fw-light">Non renseigné</span>}
                                                            </div>
                                                       </>
                                                  )}
                                                  <div className="fw-bolder mt-5 d-flex align-items-center">
                                                       Code analytique
                                                       {canEditStaffCegedimAnalytique() && (
                                                            <i className="fas fa-pen text-primary fs-8 ms-2 cursor-pointer text-hover-dark" onClick={handleEditCodeAnalytique} />
                                                       )}
                                                  </div>
                                                  <div className="text-gray-600">
                                                       {details?.personnel.codeAnalytique || <span className="text-warning fw-light">Non renseigné</span>}
                                                  </div>
                                             </>
                                        )}
                                   </div>
                              </div>
                              {/*end::Details content*/}
                         </div>
                         {/*end::Card body*/}
                    </div>
                    {/*end::Card*/}
               </div>
          </>
     )
}

export default SideBar
